// TODO this can be moved a little higher to be reused for other components

import starter from "../../Common/assets/logo/starter.webp";
import mvp from "../../Common/assets/logo/mvp.webp";
import pro from "../../Common/assets/logo/pro.webp";
import legend from "../../Common/assets/logo/legend.webp";
import vip from "../../Common/assets/logo/vip.png";
import club from "../../Common/assets/logo/club.png";
import clubFancy from "../../Common/assets/logo/club_fancy.png";

import coinsTwo from "../assets/logo/coinsTwo.png";
import coinsFive from "../assets/logo/coinsFive.png";
import coinsTwenty from "../assets/logo/coinsTwenty.png";
import coinsSixty from "../assets/logo/coinsSixty.png";
import coinsOneFifty from "../assets/logo/coinsOneFifty.png";
// import referAMateIcon from "../assets/logo/refer-a-mate-icon.png";

import cardAmex from "../assets/logo/card-logo-amex.png";
import cardDiscover from "../assets/logo/card-logo-discover.jpg";
import cardJCB from "../assets/logo/card-logo-jcb.png";
import cardMaster from "../assets/logo/card-logo-master.png";
import cardUnionPay from "../assets/logo/card-logo-union-pay.jpg";
import cardVisa from "../assets/logo/card-logo-visa.png";
import cardDefault from "../assets/logo/card-logo-default.png";
import { StripePaymentElementOptions } from "@stripe/stripe-js";
import type { SubSource } from "../config";

import fieldBlue from "../assets/images/field-blue.png";
import fieldGold from "../assets/images/field-gold-v2.png";
import fieldWhite from "../assets/images/field-white.png";
import fieldLegend from "../assets/images/field-legend.png";

import SubscriptionStarterFailed from "../assets/images/subscription-starter-failed.svg";
import SubscriptionProFailed from "../assets/images/subscription-pro-failed.svg";
import SubscriptionMVPFailed from "../assets/images/subscription-mvp-failed.svg";

import LightningGoldIcon from "../assets/icons/lightning-gold.svg";
import LightningBronzeIcon from "../assets/icons/lightning-bronze.svg";
import LightningSilverIcon from "../assets/icons/lightning-silver.svg";
import LightningPlatinumIcon from "../assets/icons/lightning-platinum.svg";
import LightningDiamondIcon from "../assets/icons/lightning-diamond.svg";

import BronzeTierIconAnimation from "../assets/animations/bronze-tier.webm";
import SilverTierIconAnimation from "../assets/animations/silver-tier.webm";
import GoldTierIconAnimation from "../assets/animations/gold-tier.webm";
import PlatinumTierIconAnimation from "../assets/animations/platinum-tier.webm";
import DiamondTierIconAnimation from "../assets/animations/diamond-tier.webm";

import BronzeTierIconAnimationAPNG from "../assets/animations/bronze-tier.png";
import SilverTierIconAnimationAPNG from "../assets/animations/silver-tier.png";
import GoldTierIconAnimationAPNG from "../assets/animations/gold-tier.png";
import PlatinumTierIconAnimationAPNG from "../assets/animations/platinum-tier.png";
import DiamondTierIconAnimationAPNG from "../assets/animations/diamond-tier.png";

export type SubscriptionType =
  | "Starter"
  | "Pro"
  | "MVP"
  | "Legend"
  | "VIP"
  | "Club";

/**
 * Membership ladder for discount bumps and upsell. Club is a separate Stripe
 * track and must stay off this list.
 */
export const MEMBERSHIP_TIER_ORDER = [
  "Starter",
  "Pro",
  "MVP",
  "Legend",
  "VIP",
] as const satisfies ReadonlyArray<Exclude<SubscriptionType, "Club">>;

const ladderSubscriptionCommonStyles = {
  Starter: {
    cardIcon: starter,
    cardStyle: {
      background: `linear-gradient(273.78deg, #898a8a 3.54%, #c9cac9 44.29%, #d2d2d7 78.99%, #b0b0b0 97.34%)`,
      color: "#030D29",
    },
    dividerStyle: {
      backgroundColor: "#8F9090",
    },
    fieldBackgroundStyle: {
      "--bg-field-image": fieldWhite,
      opacity: "30%",
    },
    failedPaymentStyle: {
      background: SubscriptionStarterFailed,
    },
  },
  Pro: {
    cardIcon: pro,
    cardStyle: {
      color: "#FFFFFF",
      background: `linear-gradient(273.78deg, #020894 3.54%, #0102f8 97.34%)`,
    },
    dividerStyle: {
      backgroundColor: "#0203F5",
    },
    fieldBackgroundStyle: {
      "--bg-field-image": fieldBlue,
      opacity: "50%",
    },
    failedPaymentStyle: {
      background: SubscriptionProFailed,
    },
  },
  MVP: {
    cardIcon: mvp,
    cardStyle: {
      color: "#030D29",
      background: `linear-gradient(269.75deg,#986b0d 0.19%,#e0a617 37.42%,#ffef98 78.16%,#a8710a 108.47%)`,
    },
    dividerStyle: {
      backgroundColor: "#9D6F0E",
    },
    fieldBackgroundStyle: {
      "--bg-field-image": fieldGold,
      opacity: "20%",
    },
    failedPaymentStyle: {
      background: SubscriptionMVPFailed,
    },
  },
  VIP: {
    cardIcon: vip,
    cardStyle: {
      color: "#030D29",
      background: `linear-gradient(220.4deg, #E2D3FF 3.08%, #EFF4FF 20.78%, #AECEFF 49.66%, #C2C9FF 70.15%, #D2EEFF 96.23%)`,
    },
    dividerStyle: {
      backgroundColor: `linear-gradient(269.75deg, rgba(41, 71, 91, 0.3) 0.19%, rgba(110, 140, 158, 0.3) 73.07%, rgba(134, 157, 172, 0.3) 108.47%)`,
    },
    fieldBackgroundStyle: {
      "--bg-field-image": fieldGold,
      opacity: "20%",
    },
    failedPaymentStyle: {
      background: SubscriptionMVPFailed,
    },
  },
  Legend: {
    cardIcon: legend,
    cardStyle: {
      color: "#FFFFFF",
      background: `linear-gradient(90deg, #000000 0%, #2F2F2F 49.5%, #000000 100%)`,
      overrideSubscriptionCardBG: "#000000",
    },
    dividerStyle: {
      backgroundColor: "#3C3C3C",
    },
    fieldBackgroundStyle: {
      "--bg-field-image": fieldLegend,
      opacity: "20%",
    },
    failedPaymentStyle: {
      background: SubscriptionMVPFailed,
    },
  },
};

export const subscriptionCommonStyles = {
  ...ladderSubscriptionCommonStyles,
  Club: {
    cardIcon: club,
    cardStyle: {
      color: "#FFFFFF",
      background: "linear-gradient(90deg, #700000 0%, #0D0000 100%)",
    },
    dividerStyle: {
      backgroundColor: "#3C0306",
    },
    fieldBackgroundStyle: {
      "--bg-field-image": fieldWhite,
      opacity: "30%",
    },
    failedPaymentStyle: {
      background: SubscriptionStarterFailed,
    },
  },
};

/** Large Club mark for the post-payment loader. Other tiers already use a 480–960px source. */
export const getSubscriptionHeroIcon = (name: SubscriptionType): string =>
  name === "Club" ? clubFancy : subscriptionCommonStyles[name].cardIcon;

const ladderDowngradeSubscriptionCommonStyle = {
  ...subscriptionCommonStyles,
  Starter: {
    ...subscriptionCommonStyles.Starter,
    downgrade: {
      currentEntries: {
        background: "#E3E3EB",
        color: "#0000FE",
      },
      newEntries: {
        background: "#E3E3EB",
        color: "#DE1125",
      },
    },
  },
  Pro: {
    ...subscriptionCommonStyles.Pro,
    downgrade: {
      currentEntries: {
        background: "#0000FE",
        color: "#FFFFFF",
      },
      newEntries: {
        background: "#DE1125",
        color: "#FFFFFF",
      },
    },
  },
  MVP: {
    ...subscriptionCommonStyles.MVP,
    downgrade: {
      currentEntries: {
        background: "#B28011",
        color: "#FFFFFF",
      },
      newEntries: {
        background: "#DE1125",
        color: "#FFFFFF",
      },
    },
  },
  VIP: {
    ...subscriptionCommonStyles.VIP,
    downgrade: {
      currentEntries: {
        background: "#B28011",
        color: "#FFFFFF",
      },
      newEntries: {
        background: "#DE1125",
        color: "#FFFFFF",
      },
    },
  },
  Legend: {
    ...subscriptionCommonStyles.Legend,
    downgrade: {
      currentEntries: {
        background: "#B28011",
        color: "#FFFFFF",
      },
      newEntries: {
        background: "#DE1125",
        color: "#FFFFFF",
      },
    },
  },
};

export const downgradeSubscriptionCommonStyle = {
  ...ladderDowngradeSubscriptionCommonStyle,
  Club: {
    ...subscriptionCommonStyles.Club,
    downgrade: ladderDowngradeSubscriptionCommonStyle.Starter.downgrade,
  },
};

export const powerUpIcons: {
  [entries: number]: string;
} = {
  2: coinsTwo,
  5: coinsFive,
  20: coinsTwenty,
  60: coinsSixty,
  150: coinsOneFifty,
};

export const powerUpTypeIcons: {
  [powerUpType: number]: string;
} = {
  1: coinsTwo,
  2: coinsFive,
  3: coinsTwenty,
  4: coinsSixty,
  5: coinsOneFifty,
};

export type PowerUpTierType =
  | "Bronze Tier"
  | "Silver Tier"
  | "Gold Tier"
  | "Platinum Tier"
  | "Diamond Tier";

export const PowerUpTypeNames = {
  1: "Bronze Tier",
  2: "Silver Tier",
  3: "Gold Tier",
  4: "Platinum Tier",
  5: "Diamond Tier",
};

export const powerUpTierBGStyles = {
  "Bronze Tier":
    "linear-gradient(213.55deg, #8C6239 0.69%, #B08457 35.35%, #EECFB6 63.19%, #D6A47B 101.51%)",
  "Silver Tier":
    "linear-gradient(213.55deg, #9C9A9A 0.69%, #BBB9B9 35.35%, #DADADA 63.19%, #A2A2A2 101.51%)",
  "Gold Tier":
    "linear-gradient(213.55deg, #986B0D 0.69%, #E0A617 35.35%, #FFEF98 63.19%, #A8710A 101.51%)",
  "Platinum Tier":
    "linear-gradient(213.55deg, #99A0A6 0.69%, #EBF3F7 35.35%, #F5F7FF 63.19%, rgba(143, 157, 171, 0.894118) 101.51%)",
  "Diamond Tier":
    "linear-gradient(213.55deg, #68B2D0 0.69%, #B2E5F6 35.35%, #E0FFFF 63.19%, rgba(88, 147, 171, 0.894118) 101.51%)",
};

export const powerUpTierBGStylesV3 = {
  "Bronze Tier":
    "radial-gradient(at bottom left, #593B2C 0%, #563630 25%, #331913 75%, #03002E 100%)",
  "Silver Tier":
    "radial-gradient(at bottom left, #3F3E40 0%, #3A3A43 25%, #212029 75%, #03002E 100%)",
  "Gold Tier":
    "radial-gradient(at bottom left, #B97800 0%, #9E6604 25%, #2D1D09 75%, #03002E 100%)",
  "Platinum Tier":
    "radial-gradient(at bottom left, #7583A2 0%, #6C789C 25%, #333E60 75%, #03002E 100%)",
  "Diamond Tier":
    "radial-gradient(at bottom left, #347FD1 0%, #3FA0FB 25%, #17235B 75%, #03002E 100%)",
};

export const powerUpTierBGBorderStylesV3 = {
  "Bronze Tier":
    "linear-gradient(229.81deg, #03002E 0%, #8C6239 15%, #B08457 40.03%, #EECFB6 80%, #D6A47B 100%)",
  "Silver Tier":
    "linear-gradient(229.81deg, #03002E 0%, #9C9A9A 15%, #BBB9B9 40.03%, #DADADA 80%, #A1A1A1 100%)",
  "Gold Tier":
    "linear-gradient(229.81deg, #03002E 0%, #332223 15%, #E0A617 40.03%, #A8710A 80%, #FFEF98 100%)",
  "Platinum Tier":
    "linear-gradient(229.81deg, #03002E 0%, #24345D 15%, #EBF3F6 40.03%, #9EB8F0 80%, #5A81D7 100%)",
  "Diamond Tier":
    "linear-gradient(229.81deg, #03002E 0%, #24345D 15%, #EBF3F6 40.03%, #9EB8F0 80%, #5A81D7 100%)",
};

export const powerUpIconsV3: {
  [tiername: string]: string;
} = {
  "Bronze Tier": LightningBronzeIcon,
  "Silver Tier": LightningSilverIcon,
  "Gold Tier": LightningGoldIcon,
  "Platinum Tier": LightningPlatinumIcon,
  "Diamond Tier": LightningDiamondIcon,
};

export const powerUpIconAnimationsV3: {
  [tiername: string]: string;
} = {
  "Bronze Tier": BronzeTierIconAnimation,
  "Silver Tier": SilverTierIconAnimation,
  "Gold Tier": GoldTierIconAnimation,
  "Platinum Tier": PlatinumTierIconAnimation,
  "Diamond Tier": DiamondTierIconAnimation,
};

export const powerUpIconAnimationsAPNGV3: {
  [tiername: string]: string;
} = {
  "Bronze Tier": BronzeTierIconAnimationAPNG,
  "Silver Tier": SilverTierIconAnimationAPNG,
  "Gold Tier": GoldTierIconAnimationAPNG,
  "Platinum Tier": PlatinumTierIconAnimationAPNG,
  "Diamond Tier": DiamondTierIconAnimationAPNG,
};

export const powerUpTextColorV3: {
  [tiername: string]: string;
} = {
  "Bronze Tier":
    "linear-gradient(213.55deg, #8C6239 0.69%, #B08457 35.35%, #EECFB6 63.19%, #D6A47B 101.51%)",
  "Silver Tier":
    "linear-gradient(213.55deg, #9C9A9A 0.69%, #BBB9B9 35.35%, #DADADA 63.19%, #A2A2A2 101.51%)",
  "Gold Tier":
    "linear-gradient(213.55deg, #986B0D 0.69%, #E0A617 35.35%, #FFEF98 63.19%, #A8710A 101.51%)",
  "Platinum Tier":
    "linear-gradient(213.55deg, #2557C1 0.69%, #EBF3F7 35.35%, #D1E0FF 63.19%, rgba(105, 147, 234, 0.894118) 101.51%)",
  "Diamond Tier":
    "linear-gradient(213.55deg, #68B2D0 0.69%, #B2E5F6 35.35%, #E0FFFF 63.19%, rgba(88, 147, 171, 0.894118) 101.51%)",
};

export const getStripeCardsLogo = (brand: string) => {
  switch (brand) {
    case "amex":
      return cardAmex;
    case "discover":
      return cardDiscover;
    case "jcb":
      return cardJCB;
    case "mastercard":
      return cardMaster;
    case "unionpay":
      return cardUnionPay;
    case "visa":
      return cardVisa;
    default:
      return cardDefault;
  }
};
export const PAYMENT_ELEMENT_OPTIONS = {
  billingDetails: {
    address: "never",
    postalCode: "never",
  },

  terms: {
    card: "never",
    googlePay: "never",
    applePay: "never",
  },
} as StripePaymentElementOptions;

/** Platform-specific store product IDs for one membership tier (Firestore `docId` per platform). */
export type MembershipTierPlatformIds = Partial<Record<SubSource, string>>;

export type MembershipTierIdsByEnv = Record<
  SubscriptionType,
  MembershipTierPlatformIds
>;

export const DEVSTG_MEMBERSHIP_TIER_IDS = {
  Starter: {
    stripe: "prod_OfnxxkAvE8cWuz",
    ios: "winners_locker_subscription_1",
    android: "product.starter:product-starter-base",
  },
  Pro: {
    stripe: "prod_OfnwpnIiyyMlm6",
    ios: "winners_locker_subscription_2",
    android: "product.pro:product-pro-base",
  },
  MVP: {
    stripe: "prod_Ofnv735IcfvmfZ",
    ios: "winners_locker_subscription_3",
    android: "product.elite:product-pro-base",
  },
  Legend: {
    stripe: "prod_QxjMortOKdk8I9",
  },
  VIP: {
    stripe: "prod_P90uZJToKnuMNM",
  },
  Club: {
    stripe: "prod_VP20KvGJoXXwm6",
  },
} satisfies MembershipTierIdsByEnv;

export const PROD_MEMBERSHIP_TIER_IDS = {
  Starter: {
    stripe: "prod_OfnKDhYc4NAP8c",
    ios: "winners_locker_subscription_starterpack",
    android: "product.starter:product-starter-base",
  },
  Pro: {
    stripe: "prod_OfnJe0DVMHStYK",
    ios: "winners_locker_subscription_professional",
    android: "product.pro:product-pro-base",
  },
  MVP: {
    stripe: "prod_OfnJDStYYnSzbC",
    ios: "winners_locker_subscription_mvp",
    android: "product.mvp:product-mvp-base",
  },
  Legend: {
    stripe: "prod_Qxk26YL2gXplr0",
  },
  VIP: {
    stripe: "prod_PAMzgb4vJmu1ND",
  },
  Club: {
    stripe: "prod_VNuqf0ZqfIXMFy",
  },
} satisfies MembershipTierIdsByEnv;

/**
 * Builds a flat `docId → tier` map from tier → platform → docId (for reverse lookup by store product ID).
 * @example `{ MVP: { stripe: "prod_abc", ios: "sub_1" } }` → `{ "prod_abc": "MVP", "sub_1": "MVP" }`
 */
const buildSubscriptionIdLookup = (
  tierIds: MembershipTierIdsByEnv
): Record<string, SubscriptionType> =>
  Object.fromEntries(
    Object.entries(tierIds).flatMap(([tier, platforms]) =>
      Object.values(platforms)
        .filter((id): id is string => id !== undefined)
        .map((id) => [id, tier as SubscriptionType])
    )
  );

/** Flat `docId → tier` lookup derived from {@link DEVSTG_MEMBERSHIP_TIER_IDS}. */
export const DEVSTG_SUBSCRIPTION_IDS = buildSubscriptionIdLookup(
  DEVSTG_MEMBERSHIP_TIER_IDS
);

/** Flat `docId → tier` lookup derived from {@link PROD_MEMBERSHIP_TIER_IDS}. */
export const PROD_SUBSCRIPTION_IDS = buildSubscriptionIdLookup(
  PROD_MEMBERSHIP_TIER_IDS
);

export const SUBS_ACCESS_LABEL: Record<SubscriptionType, string> = {
  Starter: "Basic Access",
  Pro: "High Access",
  MVP: "VIP Access",
  VIP: "VIP Access",
  Legend: "Legend Access",
  Club: "Full Access",
};

export const SUBS_POWERUP_OFFER_ON_CANCEL: {
  [id: string]: string;
} = {
  //PROD
  prod_Qxk26YL2gXplr0: "prod_P7sL0ZasDFDBeq", // "Legend", DIAMOND
  prod_OfnJDStYYnSzbC: "prod_P7sL0ZasDFDBeq", //"MVP", DIAMOND
  prod_OfnJe0DVMHStYK: "prod_P7sLt0PwA4ME0X", //"Pro", platinum
  prod_OfnKDhYc4NAP8c: "prod_P7sLdnt4lcWr0A", //"Starter", //"gold",
  prod_PAMzgb4vJmu1ND: "prod_P7sL0ZasDFDBeq", //VIP , DIAMOND

  //PROD POWER UPS
  // prod_P7sLth1ZW3yZWb: 2500, //"bronze",
  // prod_P7sLLd2nWbkuau: 5000, //"silver",
  // prod_P7sLdnt4lcWr0A: 10000, //"gold",
  // prod_P7sLt0PwA4ME0X: 20000, //"platinum",
  // prod_P7sL0ZasDFDBeq: 40000, //"diamond",

  prod_QxjMortOKdk8I9: "prod_P5ILlSKENy2qbh", //"Legend", DIAMOND
  prod_Ofnv735IcfvmfZ: "prod_P5ILlSKENy2qbh", //"MVP", DIAMOND
  prod_P90uZJToKnuMNM: "prod_P5ILlSKENy2qbh", //"VIP", DIAMOND
  prod_OfnwpnIiyyMlm6: "prod_P5IKESqzqK3teK", // "Pro", Platinum
  prod_OfnxxkAvE8cWuz: "prod_P5IKoKavViIdnl", // "Starter", GOLD
  prod_VP20KvGJoXXwm6: "prod_P5IKoKavViIdnl", // Club, GOLD
  prod_VNuqf0ZqfIXMFy: "prod_P7sLdnt4lcWr0A", // Club, GOLD

  // prod_P5IJ3AJgxyuTa3: 2500, //"bronze",
  // prod_P5IKBfL3SLEMp4: 5000, //"silver",
  // prod_P5IKoKavViIdnl: 10000, //"gold",
  // prod_P5IKESqzqK3teK: 20000, //"platinum",
  // prod_P5ILlSKENy2qbh: 40000, //"diamond",
};
